import React, { FC } from 'react';
import { style } from './style';
import { css } from 'aphrodite/no-important';
import { IBio } from 'models/bio';

interface Props {
  data: IBio;
}

export const Bio: FC<Props | null> = ({ data }) => {
  const { name, title, image_url, education, experience, bio_copy } = data;
  const styles = style();

  const renderList = (list: Array<string>) => {
    return (
      <ul>
        {list.map((listItem, i) => {
          return <li key={i}>{listItem}</li>;
        })}
      </ul>
    );
  };

  const EducationList = () => {
    if (!education.length) {
      return null;
    }
    return (
      <>
        <h4 className={css(styles.education)}>Education:</h4>
        {renderList(education)}
      </>
    );
  };

  const ExperienceList = () => {
    if (!experience.length) {
      return null;
    }
    return (
      <>
        <h4 className={css(styles.experience)}>Experience:</h4>
        {renderList(experience)}
      </>
    );
  };

  const renderEducationAndExperience = (className: string) => {
    return (
      <div className={className}>
        <EducationList />
        <ExperienceList />
      </div>
    );
  };

  return (
    <div className={css(styles.container)}>
      <div className={css(styles.detailsContainer)}>
        <div className={css(styles.imageContainer)}>
          <img src={image_url} alt='' />
        </div>
        <div className={css(styles.infoContainer)}>
          <h2 className={css(styles.name)}>{name}</h2>
          <h3 className={css(styles.title)}>{title}</h3>
          {renderEducationAndExperience(css(styles.desktopLists, styles.lists))}
        </div>
      </div>
      {renderEducationAndExperience(css(styles.mobileLists, styles.lists))}
      <div className={css(styles.bioContainer)} dangerouslySetInnerHTML={{ __html: `${bio_copy}` }}></div>
    </div>
  );
};
